import { Numeric0BoxIcon } from './Numeric0BoxIcon';

/**
 * author: Google
 * id C676CDFC-A808-4BCA-A670-49EE8478ED32
 * name numeric-0-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-0-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number0BoxIcon = Numeric0BoxIcon;
export default Number0BoxIcon